/**
 * lzy-search-shortcuts
 * ---------------------------------------------------------------------------
 * Arama modalindaki "Son Aramalarim" pill satirini yonetir.
 * - Aranan terimleri localStorage'da saklar (en fazla 6 adet).
 * - Terimleri <lzy-search-shortcuts> elementi icine pill olarak render eder.
 * - Temizle butonuyla gecmisi siler.
 */

const STORAGE_KEY = 'lzy_recent_searches';
const MAX_ITEMS = 6;

const CLOCK_ICON =
  '<svg class="lzy-pill__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
  '<circle cx="12" cy="12" r="9"></circle><polyline points="12 7 12 12 15.5 14"></polyline></svg>';

const instances = new Set();

function readTerms() {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((term) => typeof term === 'string' && term.trim().length > 0).slice(0, MAX_ITEMS);
  } catch (error) {
    return [];
  }
}

function writeTerms(terms) {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(terms.slice(0, MAX_ITEMS)));
  } catch (error) {
    /* private mode / kota dolu - sessizce gec */
  }
}

function normalize(term) {
  return String(term || '').replace(/\s+/g, ' ').trim();
}

function addTerm(rawTerm) {
  const term = normalize(rawTerm);

  if (term.length < 2 || term.length > 60) return;
  if (/^id:/i.test(term)) return;

  const lower = term.toLocaleLowerCase('tr');
  const terms = readTerms().filter((existing) => existing.toLocaleLowerCase('tr') !== lower);

  terms.unshift(term);
  writeTerms(terms);
  renderAll();
}

function clearTerms() {
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    /* noop */
  }
  renderAll();
}

function renderAll() {
  instances.forEach((instance) => instance.render());
}

function searchUrlFor(term) {
  const base = (window.Theme && window.Theme.routes && window.Theme.routes.search_url) || '/search';
  const url = new URL(base, window.location.origin);
  url.searchParams.set('q', term);
  url.searchParams.set('options[prefix]', 'last');
  return url.pathname + url.search;
}

class LzySearchShortcuts extends HTMLElement {
  handleClick = (event) => {
    const target = event.target instanceof Element ? event.target.closest('[data-lzy-recent-clear]') : null;
    if (!target) return;
    event.preventDefault();
    event.stopPropagation();
    clearTerms();
  };

  connectedCallback() {
    instances.add(this);
    this.addEventListener('click', this.handleClick);
    this.render();
  }

  disconnectedCallback() {
    instances.delete(this);
    this.removeEventListener('click', this.handleClick);
  }

  render() {
    const wrapper = this.querySelector('[data-lzy-recent]');
    const list = this.querySelector('[data-lzy-recent-list]');
    if (!wrapper || !list) return;

    const terms = readTerms();

    if (terms.length === 0) {
      wrapper.hidden = true;
      list.replaceChildren();
      return;
    }

    const fragment = document.createDocumentFragment();

    for (const term of terms) {
      const item = document.createElement('li');
      item.className = 'lzy-shortcuts__pill-item';

      const link = document.createElement('a');
      link.className = 'lzy-pill';
      link.href = searchUrlFor(term);
      link.innerHTML = CLOCK_ICON;

      const label = document.createElement('span');
      label.textContent = term;
      link.appendChild(label);

      item.appendChild(link);
      fragment.appendChild(item);
    }

    list.replaceChildren(fragment);
    wrapper.hidden = false;
  }
}

if (!customElements.get('lzy-search-shortcuts')) {
  customElements.define('lzy-search-shortcuts', LzySearchShortcuts);
}

/* --- Terim yakalama ------------------------------------------------------ */

// 1) Arama sonuc sayfasina dusuldugunde URL'deki q parametresini kaydet.
try {
  const params = new URLSearchParams(window.location.search);
  const query = params.get('q');
  const searchPath = new URL(
    (window.Theme && window.Theme.routes && window.Theme.routes.search_url) || '/search',
    window.location.origin
  ).pathname;

  if (query && window.location.pathname.indexOf(searchPath) === 0) {
    addTerm(query);
  }
} catch (error) {
  /* noop */
}

// 2) Modal icinde form gonderildiginde aninda kaydet.
document.addEventListener(
  'submit',
  (event) => {
    const form = event.target instanceof Element ? event.target.closest('.predictive-search-form') : null;
    if (!form) return;
    const input = form.querySelector('input[name="q"]');
    if (input instanceof HTMLInputElement) addTerm(input.value);
  },
  true
);

// 3) Enter ile dogrudan yonlendirme yapilan durum.
document.addEventListener(
  'keydown',
  (event) => {
    if (event.key !== 'Enter') return;
    const input = event.target;
    if (input instanceof HTMLInputElement && input.name === 'q') addTerm(input.value);
  },
  true
);